export const GLOBAL_INTERACTION = "global.interaction";
export const MANAGED_IMPRESSION = "managedImpression";
export const CITRUS_AD_CLICK = "citrusAd.clicked";
export const ANALYTICS_JLDATA_UPDATED = "JlDataUpdateComplete";
export const ADD_TO_BASKET = "plp.addToBasket";
export const ALTERNATE_IMAGE = "plp.imageAlternate";
export const FOUNDIT_CLICK = "foundit.clicked";
export const REMOVE_PRODUCT = "plp.removeProduct";
